import { Action } from "@reduxjs/toolkit";
import { Rootstate } from "../../store";

const defaultState: {
    measuring: boolean,
    measureStart: {
        x: number,
        y: number
    } | undefined
}
= {
    measuring: false,
    measureStart: undefined,
};
export interface MeasureReducerAction extends Action {
  measuring: boolean,
  measureStart: {
    x: number,
    y: number
    } | undefined,
}

const measureReducer = (state = defaultState, action: MeasureReducerAction): typeof defaultState => {
    switch (action.type) {
    case 'MEASURE/SET_STATE':
        return {
            ...state,
            measuring: action.measuring,
            measureStart: action.measureStart,

        };
    default:
        return state;
    }
};

export const measureSelector = (state: Rootstate) => state.measure;

export default measureReducer;

